import { inject, Injectable } from '@angular/core'
import { FirestorePathParams, FirestoreService } from '../../shared/modules/fire/firestore.service'
import { Order } from '../../../../domain/order.model'
import { AuthService } from '../../modules/auth/auth.service'

export interface OrderPathParams extends FirestorePathParams {
	userUid: string
}

@Injectable({ providedIn: 'root' })
export class OrdersFirestoreService extends FirestoreService<Order, OrderPathParams> {
	protected readonly authService = inject<AuthService>(AuthService)

	constructor() {
		super()
	}

	protected get collectionGroupPath(): string | undefined {
		return 'orders'
	}

	protected resolvePath(params?: OrderPathParams): string {
		params = params ?? { userUid: this.authService.userUid as string }
		return `users/${params.userUid}/orders`
	}
}
